<template>
  <div dir="rtl" class="min-h-screen  flex items-center justify-center py-12 px-4">
    <div class="w-full max-w-md">

      <form
        class="space-y-6 rounded-2xl bg-[#2B4039]/40 p-8 shadow-xl ring-1 ring-[#334D44]/60"
        @submit.prevent="login"
        novalidate
      >
        <div class="flex justify-center mb-2" >
     <img src="/img/Logo.png" width="100px"  alt="لوگوی شرکت" />
   </div>
      <p class="text-center text-lg text-white mb-9">کد ورود به   سامانه آنلاین طلا و سکه سالاری </p>
      
        <div>
          <label for="otp" class="block text-sm font-medium text-white/80 mb-2">کد پیامک‌شده</label>
          <input
            id="otp"
            name="otp"
            v-model="form.otp"
            @input="onOtpInput"
            inputmode="numeric"
            pattern="^[0-9۰-۹]{6}$"
            minlength="6"
            maxlength="6"
            autocomplete="one-time-code"
            required
            placeholder="— — — — — —"
            class="w-full rounded-xl bg-[#1e2623] text-white placeholder-white/40 px-3 py-2 ring-1 ring-[#334D44] focus:outline-none focus:ring-2 focus:ring-emerald-500 transition text-center tracking-widest"
          />
        </div>
        <button
          type="submit"
          class="w-full rounded-xl py-2.5 text-sm font-semibold bg-gradient-to-r from-[#b9f1cf] to-[#aef3c9] text-[#0a1f14] shadow-md hover:shadow-lg hover:translate-y-[-1px] active:translate-y-0 transition"
        >
          تایید کد
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'
import Swal from 'sweetalert2'

const url = process.env.VUE_APP_API_URL
const route = useRoute()
const router = useRouter()

const form = reactive({ phone: '', otp: '' })

onMounted(() => {
  if (route.query.phone) form.phone = route.query.phone
  const token = localStorage.getItem('token')
  if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`
})

function toEnglishDigits(str) {
  if (!str) return ''
  // map Arabic-Indic and Extended Arabic-Indic digits to 0-9
  return str
    .replace(/[\u06F0-\u06F9]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x06F0 + 48))
    .replace(/[\u0660-\u0669]/g, c => String.fromCharCode(c.charCodeAt(0) - 0x0660 + 48))
}

function onOtpInput(e) {
  let v = e.target.value || ''
  v = toEnglishDigits(v)           // اعداد فارسی/عربی -> لاتین
  v = v.replace(/\D/g, '')         // حذف هر چیزی جز رقم
  form.otp = v.slice(0, 6)         // حداکثر 6 رقم
}

async function login() {
  if (!form.phone) {
    Swal.fire({ toast: true, position: 'top-end', icon: 'warning', title: 'شماره موبایل موجود نیست', showConfirmButton: false, timer: 2500, timerProgressBar: true })
    router.push({ path: '/auth/login' })
    return
  }
  if (form.otp.length !== 6) {
    Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: 'کد باید ۶ رقم باشد', showConfirmButton: false, timer: 2500, timerProgressBar: true })
    return
  }

  try {
    const payload = { phone: form.phone, otp: form.otp }
    const res = await axios.post(`${url}/auth/otp`, payload)
    if (res.status === 200) {
      const token = res.data.data
      localStorage.setItem('token', token)
      axios.defaults.headers.common.Authorization = `Bearer ${token}`
      Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'به سایت خوش آمدید', showConfirmButton: false, timer: 3000, timerProgressBar: true })
      router.push('/user')
    }
  } catch (err) {
    const msg = err?.response?.data?.error_msg || 'خطا رخ داده است'
    Swal.fire({ toast: true, position: 'top-end', icon: 'error', title: msg, showConfirmButton: false, timer: 3000, timerProgressBar: true })
  }
}
</script>

<style scoped>
</style>
